<template>
    <div class="basic-tab" ref="basic-tab">
        <tab-header
            :tab-type="tpl.props.tabType"
            :fixed="tpl.props.fixedHeader"
            :tpl="tpl"
            v-model="current"
            :bodyEl="bodyEl"
            :header-style='headerStyle'
            :header-scroll-style='headerScrollStyle'
            :header-item-style='headerItemStyle'
            :header-item-active-style='headerItemActiveStyle'
            :header-active-bar-style='headerActiveBarStyle'
            ref="tabHeader"
        ></tab-header>
        <div class="basic-tab-body">
            <!-- <transition name="fade"> -->
                <inner-children-renderer v-if="_child" :children="_child" :key="_child && _child.id"/>
            <!-- </transition> -->
        </div>
    </div>
</template>

<script>
import ResizeObserver from 'resize-observer-polyfill';
import Vue from 'vue';
const {
    plugins: { ComplexComp }
} = require('@futuweb/fego-render');

import ChildItem from '../children/tab-pane/render/index.vue';
import TabHeader from './tab-header.vue';
import { CHILD } from '../constant';
import core from '../core';

export default Vue.extend({
    name: 'basic-tab',

    mixins: [
        ComplexComp.Inner.Parent.Mixins({
            [CHILD]: ChildItem
        }),
        core
    ],

    components: {
        TabHeader
    },

    props: ['tpl'],

    data() {
        return {
            bodyEl: {},
            bodyElArray: [],
            headerBoxObserver: null
        };
    },

    mounted() {
        this.initBody();
        this.initObserveHeaderBox();
    },

    watch: {
        current: {
            immediate: true,
            handler() {
                this.resetHeaderBar();
            }
        }
    },

    computed: {
        _child() {
            return this.activeChild;
        }
    },

    methods: {
        initBody() {
            this.bodyEl = this.$el.querySelector('.basic-tab-body');
            this.bodyElArray = [this.bodyEl];
        },
        initObserveHeaderBox() {
            const header = this.$refs.tabHeader;
            if (header) {
                const element = this.$el.querySelector('.basic-tab-header-real');
                this.headerBoxObserver = new ResizeObserver((entries) => {
                    this.resetHeaderBar();
                });
                if (element) {
                    this.headerBoxObserver.observe(element);
                }
            }
        }
    },

    beforeDestroy() {
        this.headerBoxObserver?.disconnect();
    }
});
</script>

<style lang="less" scoped>
@import url(../common.less);

.basic-tab {
    height: 100% !important;
}

</style>
